const fields = [
    { name: 'stateId', label: 'State', type: 'lookup-select', source: 'operational-states', labelField: 'stateName', resolveFromOptions: true, required: true },
    { name: 'commodityId', label: 'Commodity', type: 'lookup-select', idType: 'guid', source: 'commodities', labelField: 'commodityName', resolveById: true, required: true },
    { name: 'utilityCommissionName', label: 'Commission Name', type: 'text' },
    { name: 'utilityCommissionShortName', label: 'Commission Short Name', type: 'text' },
    { name: 'utilityCommissionURL', label: 'Commission URL', type: 'url' },
    { name: 'utilityCommissionCommodityServiceURL', label: 'Commodity Service URL', type: 'url' },
    { name: 'stateName', type: 'hidden', displayOnly: true },
    { name: 'commodityName', type: 'hidden', displayOnly: true },
];
export default fields;
